module.exports = {
  props: ['params'],
  data: function() {
    return {
      tabs: [{
        name: '全部',
        id: 'all'
      },{
        name: '精华',
        id: 'good'
      },{
        name: '分享',
        id: 'share'
      },{
        name: '问答',
        id: 'ask'
      },{
        name: '招聘',
        id: 'job'
      }],
      isSlide: false
    }
  },
  computed: {
    selectedTab: function() {
      return this.params.tab
    }
  },
  methods: {
    select: function(tab) {
      this.params.tab = tab
      this.params.topicId = ''
      this.params.page = 0
    }
  }
}


/** WEBPACK FOOTER **
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/menu.vue
 **/